import { css } from "styled-components";

export const font = css`
    body {
        font-family: "Source Sans Pro", sans-serif;
    }
`;
